<div class="dialog">
  <div class="header">
    <button
      appButton
      name="back"
      location="share-gallery-app-dialog"
      [iconButton]="true"
      color="simple-gray"
      height="0"
      (click)="onBack()"
    >
      <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
    </button>
    <h1>QR-Code</h1>
  </div>

  <div class="qr-container" #canvasContainer>
    <app-qr-code [content]="publicLink()" #qrCode></app-qr-code>
  </div>

  <p>
    This code contains the direct link. <span class="primary-link" (click)="openLinkSettings()">Link Settings</span>
  </p>

  <button
    appButton
    name="download-qr-code"
    location="share-gallery-qr-code-dialog"
    color="primary"
    shape="round"
    height="3"
    spacing="3"
    [center]="true"
    (click)="downloadQrCode()"
  >
    Download
  </button>
</div>
